export default __webpack_public_path__ + "static/char-s-16-jp-d8b48b6e486969854d5de21bc948f063.webp";